export default function Worker_fn() {
  return new Worker(__webpack_public_path__ + "static/js/mapbox-gl-csp-worker.e0b63806.worker.js");
}
